import { useState } from 'react';

import cn from 'classnames';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { OrbitSlider } from 'ui/molecules/OrbitSlider/OrbitSlider';
import { TestimonialCard } from 'ui/atoms/TestimonialCard/TestimonialCard';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './VoicesBlock.module.scss';

type Props = {
  title: string;
  description: string;
  className?: string;
};

const baseClass = 'voices-block';

const TESTIMONIALS = [
  {
    avatar: 'avatar-1.png',
    name: 'Adam Mulliken',
    role: 'CPO, Quantifind',
    logo: 'quantifind.svg',
    description:
      '"When you\'re resolving entities and mapping risk across borders, the foundation has to be authoritative and traceable — a registry-sourced record we can stand behind when a decision is questioned. Global Database gives us that across the markets we\'re expanding into, and their team absorbs the registry-level differences and constant changes, so ours stays focused on the intelligence layer rather than the data plumbing."',
  },
  {
    avatar: 'avatar-2.png',
    name: 'Carol Zhang',
    role: 'Associate Vice President, Kroll',
    logo: 'kroll.svg',
    description:
      '"We use Global Database\'s credit risk data when verifying and onboarding customers. It gives our teams the company and financial information they need to assess risk, complete checks and make decisions with confidence."',
  },
  {
    avatar: 'avatar-3.png',
    name: 'Alexandre Outman',
    role: 'Lead Product Manager, Trustpair',
    logo: 'trustpair.svg',
    description:
      '"We use Global Database to enrich our bank account validation and payee checks with business data. It helps us identify the company behind the payment and gives our customers more confidence before they pay."',
  },
];

export const VoicesBlock = ({ title, description, className }: Props) => {
  const [id, setId] = useState(0);

  const onPrev = () => setId((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const onNext = () => setId((i) => (i + 1) % TESTIMONIALS.length);

  return (
    <section className={cn(styles[`${baseClass}-wrapper`], className)}>
      <div className={styles[`${baseClass}-container`]}>
        <TitleBlock title={title} description={description} />

        <div className={styles[`${baseClass}-slider`]}>
          <button className={styles[`${baseClass}-arrow`]} onClick={onPrev} aria-label="Previous">
            <Icon type="arrow-5" />
          </button>

          <div className={styles[`${baseClass}-inner`]}>
            <OrbitSlider className={styles[`${baseClass}-orbit-slider`]} />

            <div className={styles[`${baseClass}-content`]} key={id}>
              <TestimonialCard {...TESTIMONIALS[id]} />
            </div>
          </div>

          <button className={styles[`${baseClass}-arrow`]} onClick={onNext} aria-label="Next">
            <Icon type="arrow-6" />
          </button>
        </div>
      </div>
    </section>
  );
};
